import BaseInteractionService from '@configuratorware/configurator-frontendgui/App/Services/InteractionService';
import { Services } from "@configuratorware/configurator-frontendgui/App/ServiceLocator";
import { getConf, SaveTypes } from "@configuratorware/configurator-frontendgui/App/configuration.js";
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';
import { addToBasket } from '../Reducers/Basket/Actions';

export default class InteractionService extends BaseInteractionService {
    async addToCart() {
        const { ui, configurator } = Services;

        ui.dismissError();
        ui.beginWork('addToCart');
        ui.hide('optionlist');
        ui.show('addToCartPopUpLoader');

        try {
            const overwriteConfiguration = getConf('fromBasket', false);

            const extraData = overwriteConfiguration
                ? { code: Services.configurator.state.configuration.code }
                : {};
            ui.show('globalLoader');
            const result = await configurator.captureAndSaveConfiguration(SaveTypes.CART, extraData);
            const { code, configurationType } = result.data;
            code && configurationType !== "defaultoptions" && Services.store.dispatch(addToBasket(code, {showSelector: true}));
            ui.hide('globalLoader');
            Services.configurator.addToCartCallback(result.data);
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
            ui.reportError(t('saveConfiguration.error.savingFailed'));
            throw e;
        } finally {
            ui.endWork('addToCart');
            ui.hide('addToCartPopUpLoader');
        }
    }
}
